import prepareFriendlyUri from '@utils/prepareFriendlyUri';

const getProductUrl = (productName: string, productId: number | string): string => {
  const friendlyUriProductName = prepareFriendlyUri(productName);
  return `/product/${friendlyUriProductName}-${productId}`;
};

export default getProductUrl;
